import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=83391174&scoped=true&"
import script from "./Pager.vue?vue&type=script&lang=ts&"
export * from "./Pager.vue?vue&type=script&lang=ts&"
import style0 from "./Pager.vue?vue&type=style&index=0&id=83391174&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83391174",
  null
  
)

export default component.exports